import StorageManager from '@/services/sessionStorageManager';

export default {
  methods: {
    /** Salva o filtro no storage e redireciona para tela
     * de histórico de operações com o id do filtro salvo na rota
     * @param filter.companiesIds ids das empresas
     * @param filter.regionalIds ids das regionais
     * @param filter.installationsIds ids das instalações
     * @param filter.assetsIds ids dos ativos
     * @param filter.operationTypes tipos de operações
     * @param filter.period periodo filtrado (Não utilizado se utilizar periodo final e inicial)
     * @param filter.finalDate periodo final
     * @param filter.initialDate periodo inicial
     * @param page página atual
     * @param pageSize tamanho da página
     * @param filter.genericSearch busca genérica
     * @param filter.usersIds ids dos usuários
    */
   /* istanbul ignore next */
    openOperationHistoryReport(filter) {
      this.saveOnCacheAndOpenNewWindow(filter,
        'operationsHistoryFilter',
        'clean-view.operations-history.view-report');
    },
    /** Salva o filtro no storage e redireciona para tela
     * de histórico de operações com o id do filtro salvo na rota
     * @param filter.companiesIds ids das empresas
     * @param filter.regionalIds ids das regionais
     * @param filter.installationsIds ids das instalações
     * @param filter.assetsIds ids dos ativos
     * @param filter.operationTypes tipos de operações
     * @param filter.period periodo filtrado (Não utilizado se utilizar periodo final e inicial)
     * @param filter.finalDate periodo final
     * @param filter.initialDate periodo inicial
     * @param page página atual
     * @param pageSize tamanho da página
     * @param filter.genericSearch busca genérica
     * @param filter.usersIds ids dos usuários
    */
   /* istanbul ignore next */
    openOperationHistory(filter) {
      this.saveOnCacheAndOpenNewWindow(filter,
        'operationsHistoryFilter',
        'clean-view.operations-history.view-report');
    },
    /*
      @deprecated Não utilizar fora do mixin
     */
    /* istanbul ignore next */
    saveOnCacheAndOpenNewWindow(filter, storageName, route) {
      const redirectedFilter = { ...filter, redirected: true };
      const stringifyFilter = JSON.stringify(redirectedFilter);
      const storageKey = StorageManager.setItemWithId(storageName, stringifyFilter);
      const routeData = this.$router.resolve({
        name: route,
        query: {
          filter: storageKey,
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
